module.exports = __webpack_public_path__ + "static/media/AMBUJACEM_F1.d6ac8248.txt";